import React from "react";

const Footer = () => {
  return <footer>
    <p>Made by <a href="https://www.onemodel.app/" title="Start diagramming now with onemodel.app">onemodel.app</a></p>
  </footer>
};

export default Footer;
